export default __webpack_public_path__ + "static/media/6.8062189c.svg";